import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from "@angular/router";
import { ResolutionService } from '../resolution.service';
import { OrderService } from "../order.service";
import { SignalsStoreService } from "../signals-store.service";
import { LocalStorageService } from '../local-storage.service';
import { LOCALSTORAGE_KEYS } from '../constants/databases';

@Component({
  selector: 'app-mobile-footer-menu',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './mobile-footer-menu.component.html',
  styleUrl: './mobile-footer-menu.component.scss'
})
export class MobileFooterMenuComponent {
  signalsStoreService = inject(SignalsStoreService);
  private orderService = inject(OrderService);
  private resolutionService = inject(ResolutionService);
  private localStorageService = inject(LocalStorageService);
  isMobile = computed(() => this.resolutionService.isMobile());
  orderProductsQuantity = computed(() => this.getOrderProductsQuantity());

  getOrderProductsQuantity() {
    const orders = this.orderService.orders();
    if (!orders.length) return 0;
    const order = orders[0] || [];
    const allProducts = [
      ...(order?.products?.common ?? []),
      ...(order?.products?.subscription ?? []),
    ];

    if (order?.isSkipped) return 0;

    return new Set(allProducts.map((product: any) => {
      const variantId = product.variant.id;
      const packageId = product.package?.id || null;
      const id = `${variantId}${packageId ? `_${packageId}` : ''}`;
      return id
    })).size;
  }

  returnLink() {
    const order = this.signalsStoreService.firebaseOrder();
    const hasProducts = order?.products?.common?.length || order?.products?.subscription?.length;

    return hasProducts ? '/cart' : '/order';
  }

  rememberRouteIfNoSession(route: string) {
    if (this.signalsStoreService.hasSession()) return;
    this.localStorageService.set(LOCALSTORAGE_KEYS.ROUTE_TO_NAVIGATE_AFTER_LOGIN, route);
  }
}
